import React, { createContext, useContext, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ToastMessage, { showToast } from '@/utils/toastMessage/ToastMessage';

/**
 * Toast configuration settings.
 */
// const config = {
//   position: 'top-right',
//   autoClose: 3000,
//   closeOnClick: true,
//   draggable: true,
//   theme: 'colored',
//   pauseOnFocusLoss: false,
// };
//
// Create Toast Context
const ToastContext = createContext();

/**
 * ToastProvider component to wrap the application and provide toast functionality.
 */
export const ToastProvider = ({ children }) => {
  // const [toastConfig] = useState(config);

  /**
   * Show a toast notification with a specified message and type.
   *
   * @param {string} message - The message to display in the toast.
   * @param {string} [type="success"] - The type of toast notification ("success", "error", "warn", "info").
   */
  // const showToast = (message, type = 'success') => {
  //   toast.dismiss(); // Dismiss any existing toasts
  //   switch (type) {
  //     case 'success':
  //       toast.success(message, toastConfig);
  //       break;
  //     case 'error':
  //       toast.error(message, toastConfig);
  //       break;
  //     case 'warn':
  //       toast.warn(message, toastConfig);
  //       break;
  //     case 'info':
  //       toast.info(message, toastConfig);
  //       break;
  //     default:
  //       toast.info(message, toastConfig);
  //   }
  // };

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <ToastMessage />
      {/*<ToastContainer
        theme="colored"
        toastStyle={{
          minHeight: '30px',
        }}
        style={{
          fontSize: '1rem',
          width: 'auto',
          minWidth: '200px',
          fontWeight: 700,
          padding: '10px',
        }}
      />*/}
    </ToastContext.Provider>
  );
};

/**
 * Custom hook to access toast functionality.
 */
export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

export default ToastProvider;
